import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import NavBar from "../src/components/common/NavBar";

Modal.setAppElement('#root');

const baseURL = process.env.PUBLIC_URL + '/assets/';

const HomeModal = () => {
  const [isOpen, setIsOpen] = useState(true);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    // Close modal on any click on the page
    const handleClickAnywhere = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickAnywhere);

    return () => {
      document.removeEventListener("click", handleClickAnywhere);
    };
  }, [isOpen]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <div className="relative z-40">
      <NavBar />
      <Modal
        isOpen={isOpen}
        className="fixed inset-0 flex items-center justify-center z-50 overflow-y-auto"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md"
        shouldCloseOnOverlayClick={false} // Disable default behavior
        shouldCloseOnEsc={false} // Optional: disable ESC to force only click close
      >
        <div
          className="relative w-1/3 h-3/4 mt-20 max-md:w-3/4 max-md:h-2/3"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside image container
        >
          <img
            src={`${baseURL}/popup.jpeg`}
            className="z-60 h-full w-full cursor-pointer"
            alt="Modal"
          />
          <button
            onClick={handleCloseModal}
            className="absolute top-2 right-2 z-100 text-white text-3xl font-bold rounded-full p-2 hover:bg-red-600"
          >
            <img src={`${baseURL}/x.png`} alt="Close" />
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default HomeModal;
